import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { AlertsService } from 'src/modules/base/services/alerts.service';
import { AuthenticationService } from 'src/modules/base/shared/services/authentication.service';
import { BaseService } from 'src/modules/base/shared/services/base.service';
import { TelemedicineService } from '../../services/telemedicine.service';
import _moment from 'proxies/dayjs';

@Component({
    selector: 'kx-telemedicine-guest-page',
    templateUrl: './telemedicine-guest-page.component.html',
    styleUrls: ['./telemedicine-guest-page.component.scss'],
    standalone: false
})
export class TelemedicineGuestPageComponent implements OnInit {
  moment = _moment;

  constructor(
    private teleService: TelemedicineService,
    private a_route: ActivatedRoute,
    private baseService: BaseService,
    private alert: AlertsService,
    private auth: AuthenticationService,
    private router: Router,
  ) { }

  ngOnInit(): void {
    if(!this.a_route.snapshot.queryParams.user_id){
      this.redirectPage();
      return
    }
    if (this.auth.getUserType() != "patient") {
      this.alert.error("Please login with Patient")
      this.redirectPage()
      return
    }

    if (this.auth.getCurrentUser().user_id != this.a_route.snapshot.queryParams.user_id) {
      this.alert.error("User is not same");
      this.redirectPage()
      return
    }

    this.baseService.get("GET_BY_ID", "id:" + this.a_route.snapshot.queryParams.channel_id, "service_request", "order").subscribe((res: any) => {
      if (res.errCode == 0) {
        if (res.resource.length == 0) {
          this.redirectPage()
          this.alert.error("Channel id is not correct");
          return
        } else {
          if (res.resource[0].status.toLowerCase() != "pending") {
            this.redirectPage()
            this.alert.error("Current appointment is " + res.resource[0].status);
            return
          } else if (res.resource[0].consultation_type_code != 'video') {
            this.redirectPage()
            this.alert.error("This is not correct consultation type");
            return
          } else if (res.resource[0].serviceDate != this.moment().startOf('day').valueOf()) {
            this.redirectPage()
            this.alert.error("Appointment date is not today");
            return
          } else {
            this.getResourceDef(res.resource[0])
          }
        }
      } else {
        this.redirectPage()
        this.alert.error(res.message)
        return
      }
    })
  }

  getResourceDef(resource: any) {
    this.baseService.getResourceDef(this.a_route.snapshot.queryParams.resource_name, (resourcedef) => {
      if (resourcedef) {
        var action = resourcedef.capability.find(x => x["appLink"] == "videocall")
        this.teleService.initCallData(resource.participant_details[0].participantId, resource.participant_details[0].participantName, this.a_route.snapshot.queryParams.channel_id, resource.orderId, action, resource);
      } else {
        this.redirectPage()
        this.alert.error("Resource not found")
        return
      }
    })
  }

  redirectPage() {
    this.router.navigate(['/login'],{ queryParams: { returnUrl: this.router.url } });
  }

}
